import { render, staticRenderFns } from "./relatedBrand.vue?vue&type=template&id=d6969cdc&scoped=true"
import script from "./relatedBrand.vue?vue&type=script&lang=js"
export * from "./relatedBrand.vue?vue&type=script&lang=js"
import style0 from "./relatedBrand.vue?vue&type=style&index=0&id=d6969cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6969cdc",
  null
  
)

export default component.exports